import React, { 
    useState, 
    useEffect 
} from 'react';
import { 
    useHistory, 
    useParams 
} from "react-router-dom";
import { 
    Card, 
    Form, 
    Row, 
    Col, 
    Button, 
    Badge 
} from 'react-bootstrap';
import { isMobile } from "react-device-detect";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import MaskedInput from 'react-maskedinput';
import axios from 'axios';

import ComboModeloSms from '../../Componentes/ComboModeloSms';
import TextoWhatsapp from '../../ModelosWhatsapp/Cadastrar/TextoWhatsapp';

// componente
export default function EnviarWhatsapp({
    aniversariante='N'
}){

    // resgata parametros da rota
    const { idade, id, idcliente } = useParams();
    const history = useHistory();
    
    // estados
    const [dados, alterarDados] = useState({
        id: id || null,
        id_cliente: idcliente || null,
        mensagem: '',
        celular: '',
        data_agendado: null,
        tipo_aniversariante: aniversariante,
        idade_referencia: idade || null,
        flashsms: 'N'
    });
    const [dadosCliente, alterarDadosCliente] = useState(null);
    const [carregando, alterarCarregando] = useState(true);
    const [salvando, alterarSalvando] = useState(false);

    // referências
    const telCelInput = React.createRef();    
    
    // faz o envio
    async function enviar() {
        // ativa o carregamento do envio
        alterarSalvando(true);

        try {
            
            // envia mensagem de whatsapp ao cliente
            await axios.post("/whatsapp-enviado/enviar", {
                idCliente: dadosCliente.id,
                mensagem: dados.mensagem,
                idadeReferencia: idade || null,
                tipoAniversariante: aniversariante
            });

            // mensagem de cadastro realizado com sucesso
            toast(({ closeToast }) => <>
                <div className="toast-header">
                    <strong className="mr-auto">{dadosCliente.nome}</strong>
                    <button 
                        onClick={closeToast} 
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body">
                    Whatsapp enviado com sucesso!                    
                </div>
            </>, { autoClose: 5000 });

            // vai para a consulta de sms's enviados (por enquanto volta para a consulta de clientes)
            history.push('/painel/mensagens-whatsapp');

        } catch(e) {
            console.log(e)
        } finally {
            // desativa o carregamento
            alterarSalvando(false);
        }   

    }

    // carregar modelo de whatsapp com as informaões do cliente
    function carregarModelo(idModelo) {

        // faz a requisição para carregar o modelo com os dados do cliente
        axios.get(`/modelosSms/${idModelo}/convertido/${dados.id_cliente}`)
        .then(({ data }) => {
            dados.mensagem = data.mensagem;
            alterarDados({ ...dados });
        });
    }

    // inicializa
    useEffect(() => {

        // verifica se é edição ou cadastro
        if(idcliente){

            // consulta os dados do cliente
            axios.get(`/clientes/${dados.id_cliente}`)
                .then(({ data }) => {
                    alterarDados({
                        ...dados,
                        celular: `55${data.dados.telefone_celular}`
                    });
                    alterarDadosCliente(data.dados);
                })
                .catch(e => {
                    console.error(e);
                })
                .then(() => {
                    alterarCarregando(false);
                })
            ;

        }
        
        // se for whatsapp para um aniversariante
        if(aniversariante === "S") {
            // verifica o id para carregar o modelo de aniversario
            const idModeloWhatsappAniversario = process.env.NODE_ENV === 'development' ? 54 : 79;
            
            // carrega o modelo de aniversario
            carregarModelo(idModeloWhatsappAniversario);
        }


    }, []);

    // se estiver carregando
    if(carregando){
        return <>Carregando ...</>
    }

    return (
        <Row>
            <Col lg={8}>
                <Card className={'border-0 shadow-sm'}>
                    <Card.Header className={'bg-white border-0'}>
                        <Card.Title as='h4'>Enviar Whatsapp</Card.Title>
                    </Card.Header>
                    <Card.Body className='pt-0'>
                        <Form.Row>
                            <Col lg={8}>
                                <Form.Label>Nome: </Form.Label>
                                <b> {dadosCliente.nome}</b>
                            </Col>
                            <Col lg={4}>
                                <Form.Label>Celular</Form.Label>
                                <MaskedInput 
                                    className="form-control"
                                    mask="+11 (11) 11111-1111"
                                    value={dados.celular}
                                    ref={telCelInput}
                                    onChange={(e) => {
                                        alterarDados({...dados, celular: telCelInput.current.mask.getRawValue().split('_').join('')});
                                    }}
                                />
                            </Col>
                        </Form.Row>
                        <Form.Group style={{ height: 250 }} className='mt-4'>
                            <Form.Label>Mensagem</Form.Label>
                            <TextoWhatsapp 
                                value={dados.mensagem}
                                onChange={e => {
                                    dados.mensagem = e.target.value;
                                    alterarDados({...dados});
                                }}
                                classe='h-75'
                            />
                        </Form.Group>
                        <p className={'text-right'}>
                            <span>Caractéres </span> 
                            <Badge variant={'info'}>
                                {dados.mensagem.length}
                            </Badge>
                        </p>
                    </Card.Body>
                </Card>
                <Form.Group className="d-flex justify-content-around my-4">
                    <Button variant="danger" onClick={() => {
                        history.goBack();
                    }}>
                        <span>Cancelar</span>
                    </Button>
                    <Button 
                        variant="success" 
                        disabled={salvando} 
                        onClick={() => isMobile 
                            ? `whatsapp://send?phone=${encodeURIComponent(dados.celular)}&text=${encodeURIComponent(dados.mensagem)}` 
                            : window.open(`https://api.whatsapp.com/send?phone=${encodeURIComponent(dados.celular)}&text=${encodeURIComponent(dados.mensagem)}`)
                        }
                    >
                        {salvando ? 
                            <>
                                <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                                <span>Enviando</span>
                            </> : 
                            <span>Enviar whatsapp</span>
                        }
                    </Button>
                </Form.Group>
            </Col>
            <Col lg={4}>
                <Card className={'border-0 shadow-sm'}>
                    <Card.Body>
                        <ComboModeloSms 
                            alterou={carregarModelo}
                            tipo={['3']}
                            placeholder={'Escolher modelo de whatsapp'}
                        />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )

    

}